module.exports = __webpack_public_path__ + "static/media/AboutUsBanner.719b8607.png";